import cookieClient from 'react-cookies';
import { SECURE_COOKIE } from "@globalConfig";

/**
 * UTM marketing attribution parameters.
 *
 * Captured from the landing URL and persisted in a cookie for 30 days so they
 * can be attached to create-order / send APIs for reporting and filtering.
 */

var COOKIE_NAME = "utm_params";
var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
var COOKIE_OPTS = {
  path: "/",
  maxAge: 3600 * 24 * 30,
  // 30 days
  sameSite: true,
  secure: SECURE_COOKIE
};

/**
 * Read the UTM params from the current URL and, when present, persist them in a
 * cookie (last-touch attribution, 30-day lifetime). Client-side only; call once
 * on app bootstrap. Returns the effective UTM params (freshly captured or
 * previously stored).
 */
export function captureUtmParams() {
  if (typeof window === "undefined" || !window.location) return {};
  var params = new URLSearchParams(window.location.search);
  var fromUrl = {};
  UTM_KEYS.forEach(function (key) {
    var value = params.get(key);
    if (value) fromUrl[key] = value;
  });
  if (Object.keys(fromUrl).length > 0) {
    cookieClient.save(COOKIE_NAME, JSON.stringify(fromUrl), COOKIE_OPTS);
    return fromUrl;
  }
  return cookieClient.load(COOKIE_NAME) || {};
}

/**
 * Return the stored UTM params for inclusion in request bodies.
 * Only keys that were actually captured are present, so the result is safe to
 * spread directly into a create-order / send payload. Client-side only.
 */
export function getUtmParams() {
  if (typeof window === "undefined") return {};
  return cookieClient.load(COOKIE_NAME) || {};
}